export function DefaultIcon({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.6668 3.5L5.25016 9.91667L2.3335 7"
        stroke="#6B6B6B"
        strokeWidth="0.933333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
